import { render } from "./AlertOctagonOutline.vue?vue&type=template&id=642b9664"
import script from "./AlertOctagonOutline.vue?vue&type=script&lang=js"
export * from "./AlertOctagonOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__